import React from 'react';

interface ThreeMonthPlanEmptyProps {
  studentName: string;
  teacherName?: string;
}

const DangerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 21.4093H5.93999C2.46999 21.4093 1.01999 18.9293 2.69999 15.8993L5.81999 10.2793L8.75999 4.9993C10.54 1.7893 13.46 1.7893 15.24 4.9993L18.18 10.2893L21.3 15.9093C22.98 18.9393 21.52 21.4193 18.06 21.4193H12V21.4093Z"
      fill="#AD9502"
      stroke="#AD9502"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 9V14"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.9945 17H12.0035"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const ThreeMonthPlanEmpty: React.FC<ThreeMonthPlanEmptyProps> = ({ studentName, teacherName }) => {
  return (
    <div className="flex items-center gap-[14px] w-full min-h-[72px] px-[14px] py-[13px] rounded-[8px] bg-[#FEFBE8] border border-[#F4EEC9]">
      <div className="shrink-0 w-[45px] h-[45px] rounded-full bg-[#F0ECD5] flex items-center justify-center">
        <DangerIcon />
      </div>
      <div className="flex flex-col gap-[4px]">
        <p className="font-semibold text-[14px] leading-[1.2] text-[#6A6327] m-0">
          {studentName}&apos;s Health Evaluation is Pending
        </p>
        <p className="font-medium text-[12px] leading-[1.2] text-[#797447] m-0">
          {teacherName
            ? `Contact ${teacherName} to complete the evaluation to generate their health profile and projections.`
            : 'No evaluation has been done yet.'}
        </p>
      </div>
    </div>
  );
};

export default ThreeMonthPlanEmpty;
